import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { IOptionsResponse } from '../../../common/common.types'
import { setCvArtOptions } from '../store/options.actions'
import { OptionsService } from '../services/options.service'

export function* getCardioArtOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getCardioArtOptions])
    const { entity } = response
    yield put(setCvArtOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getCardioArtOptions() error: ${e}`))
  }
}

export function* getCardioArtOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getCardioArtOptions)
}
